export const environment = {
  production: false,
  baseUrlApi: 'https://api-dev.siscontrol.ch',
  baseUrlPublicAssets: 'https://devsiscontrolpublic.blob.core.windows.net/public-assets',
  sisControlPublicUrl: 'https://dev.siscontrol.ch',
  titlePrefix: '[DEV] ',
};
